<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body {
  margin: 0px;
  padding: 0px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
}
.g2-tooltip-value {
  margin-left: 8px!important;
}
.el-table tbody .cell:empty::before{
  content:'——';
  color:gray;
}
#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}
.aresWidth .el-input {
    width: 275px!important;
    margin-right: 10px;
}
.aresWidth .el-input--suffix .el-input__inner {
  width: 210px !important;
}
.product-table .el-table__empty-text {
 display: none;
}
.activityCodeTable .el-table__header tr th{
  background-color: #FAFAFA!important;
  border-bottom: 1px solid #E8E8E8;
  line-height: 35px;
}
 .qrcodeUrl-code .el-form-item__content {
    height: 80px!important;
  }
.activityCodeBox .el-checkbox__input.is-disabled+span.el-checkbox__label {
  color: #1890FF;
}
.order-list-table th {
  background-color: #fafafa;
  line-height: 30px;
  border-bottom: 1px solid #e2e3e3;
}
.el-table th.is-leaf:first-child {
  border-right: 1px solid #fff!important;
}
.el-table th.is-leaf:first-child:hover {
    border-right: 1px solid #ebeef5!important;
}
.activityCodeBox .el-radio__input.is-disabled+span.el-radio__label {
  color: #1890FF;
}

.order-list-table th {
  background-color: #fafafa;
  line-height: 30px;
  border-bottom: 1px solid #e2e3e3;
}
.table-div .ant-table-pagination.ant-pagination {
  /*margin: 0px!important;*/
  float: none!important;
}
.table-div .ant-table-placeholder {
  border-bottom: 0px!important;
}
.vue-grid-item>.vue-resizable-handle {
  opacity: 0;
}
.item-content .vue-grid-item>.vue-resizable-handle:hover {
  opacity: 1;
}
.group-search_1 .el-input__inner {
  width: 189px!important;
}
</style>
